import React from "react";
import Header from "./Header";
import Footer from "./Footer";

function Termsandconditions() {
  return (
    <div>
      <Header />
      <div>
      <div className="page-header parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header-box">
                <h1 className="text-anime">Terms and conditions</h1>
                <div
                  className="post-single-meta wow fadeInUp"
                  data-wow-delay="0.25s"
                >
                  <ul className="breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li className="active">Terms and conditions</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="container my-2">
        <div className="row">
          <div className="col-md-12">
            <h2>Terrmass Conditlsm</h2>
            <p>
              Welcome to our terms and conditions. By using our website, you
              agree to comply with and be bound by the following terms. Please
              read them carefully.
            </p>
            <h4>1. Introduction</h4>
            <p>
              These terms govern your use of our website and services. If you do
              not agree, please do not use our platform.
            </p>
            <h4>2. User Responsibilities</h4>
            <p>
              Users must adhere to all applicable laws and refrain from any
              harmful activities while using this site.
            </p>
            <h4>3. Changes to Terms</h4>
            <p>
              We reserve the right to modify these terms at any time. Please
              check back regularly for updates.
            </p>
          </div>
        </div>
      </div> */}
    </div>
      <Footer />
    </div>
  );
}

export default Termsandconditions;
